export function mergeObjects(
    object1: {
        [key: string]: {
            [key: string]: string;
        };
    },
    ...objects: {
        [key: string]: {
            [key: string]: string;
        };
    }[]
) {
    const result: {
        [key: string]: {
            [key: string]: string;
        };
    } = { ...object1 };
    for (const extraObject of objects) {
        for (const key of Object.keys(extraObject)) {
            result[key] = { ...result[key], ...extraObject[key] };
        }
    }
    return result;
}
